import React, { useState, useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Loading from '../pages/LoadingPage';
import { getUser, getBlockCheck } from '../Users'

const CompActiveCheck = ({ currentUser, element }) => {
    const {userId, pageCode} = useParams();
  const [isAuth, setIsAuth] = useState(3); // 3 = Loading, 2 = Authenticated, 1 = Not authenticated

  useEffect(() => {
    const isAuthenticated = async () => {
      if((pageCode && Number(pageCode) === 1) || Number(currentUser.id) === Number(userId)) {
          return 2;
      } else if (currentUser.status === 2 ) {
        const pageOwner = await getUser(userId);
        const blockCheck = await getBlockCheck(currentUser.id, userId);
        if (blockCheck) return 1;
        console.log(pageOwner);
        if ((pageOwner.status >= 1 && pageOwner.blockCount >= 10) || pageOwner.status >= 2) return 2;
        else return 1;
      } else {
        return 1;
      }
    };

    const checkAuth = async () => {
      const authResult = await isAuthenticated();
      setIsAuth(authResult); // Correctly setting state based on the result of isAuthenticated
    };

    checkAuth();
  }, [currentUser, userId, pageCode]); // Empty dependency array means this runs once on component mount


  if (isAuth === 3) {
    return <Loading />; // Show loading while authentication is being checked
  }

  return isAuth === 2 ? element : <Navigate to="/" />;
};

const ActiveCheck = ({ currentUser, element }) => {
    const {userId} = useParams();
  const [isAuth, setIsAuth] = useState(3); // 3 = Loading, 2 = Authenticated, 1 = Not authenticated

  useEffect(() => {
    const isAuthenticated = async () => {
      if(currentUser.status === 2) {
          return 2;
      } else {
          return 1;
      }
    };

    const checkAuth = async () => {
      const authResult = await isAuthenticated();
      setIsAuth(authResult); // Correctly setting state based on the result of isAuthenticated
    };

    checkAuth();
  }, [currentUser, userId]); // Empty dependency array means this runs once on component mount


  if (isAuth === 3) {
    return <Loading />; // Show loading while authentication is being checked
  }

  return isAuth === 2 ? element : <Navigate to="/" />;
};

export { CompActiveCheck, ActiveCheck};